import { TwtOrderContext } from '~/tenants/twt/model/TwtOrder';
import TwtPhotoConfig from '~/tenants/twt/performable/photo/TwtPhotoConfig';
import TwtVideoConfig from '~/tenants/twt/performable/video/TwtVideoConfig';
import TwtAerialConfig from '~/tenants/twt/performable/aerial/TwtAerialConfig';
import { twt_version, TwtVersion } from '~/tenants/twt/data';
import { datetime } from '~/lib/datettime';

export const TWT_JONNY_PERFORMABLES = [TwtPhotoConfig, TwtVideoConfig, TwtAerialConfig];

export function twt_jonny_eligible(context: TwtOrderContext) {
  if (context.parent?.package_jonny === true && twt_version(context.created, TwtVersion.V6)) {
    return true;
  }

  return context.buyer.metadata.package_jonny === true && (context.metadata.sqft ?? 0) <= 5000;
}

export function twt_jonny_configured(order: TwtOrderContext) {
  const date = order.buyer.metadata.discount_percentage_date ?? order.parent?.discount_percentage_date;

  if (date) {
    if (datetime(order.created, order.timezone) >= datetime(date, order.timezone)) {
      return false;
    }
  } else if (twt_version(order.created, TwtVersion.V17)) {
    return false;
  }

  return (
    twt_jonny_eligible(order) && TWT_JONNY_PERFORMABLES.every((p) => order.jobs.some((j) => j.performable_id === p.id))
  );
}
